import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { Button } from '~/components/ui';
import { useAcceptQuote } from '~/api';
import { sellerLabel, toastGraphQLError } from '~/utils';
import type { Quote } from './splitAwardGridTypes';

type AcceptQuoteButtonProps = Readonly<{
  quote: Pick<Quote, 'id' | 'sellingOrganization'>;
  disabled: boolean;
  onAccepted?: (quoteId: string) => void;
}>;

export function AcceptQuoteButton({
  quote,
  disabled,
  onAccepted,
}: AcceptQuoteButtonProps) {
  const { t } = useTranslation('rfq-view');
  const { mutateAsync: acceptQuote, isPending: isAccepting } = useAcceptQuote();

  const handleAccept = async () => {
    try {
      await acceptQuote({ id: quote.id });
      toast.success(t('rfq_view.quote_accepted'));
      if (onAccepted) {
        onAccepted(quote.id);
      }
    } catch (error) {
      toastGraphQLError(error);
    }
  };

  return (
    <Button
      variant="primary"
      size="sm"
      width="auto"
      aria-label={t('rfq_view.accept_quote_aria_label', {
        sellerName: sellerLabel(quote.sellingOrganization),
      })}
      onClick={() => void handleAccept()}
      disabled={disabled || isAccepting}
      loading={isAccepting}
    >
      {t('rfq_view.accept_quote')}
    </Button>
  );
}
